import {FieldParameters} from '../core/field-parameters';
import {EventEmitter} from '@angular/core';

export class FieldActionParameters extends FieldParameters {
  trigger: string;
  newData: any;
  closeEdit: EventEmitter<any>;
}
